// app/javascript/controllers/dae20/button_group_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenInput"]
  static values = {
    multi: { type: Boolean, default: false },
    inputName: { type: String, default: "" },
    activeClasses: { type: String, default: "bg-blue-600 text-white border-blue-600" },
    inactiveClasses: { type: String, default: "bg-white text-gray-700 border-gray-300" }
  }

  connect() {
    this._selected = new Set()
    this._restoreFromUrl()
    this._updateVisual()

    // Слушаем событие от filter_controller при восстановлении из URL
    document.addEventListener("filter:restored", () => {
      this._restoreFromUrl()
      this._updateVisual()
    })
  }

  selectOption(event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.value

    if (value === "") {
      // "Все" — сбросить выбор
      this._selected.clear()
    } else if (this.multiValue) {
      // Multi-select: toggle
      if (this._selected.has(value)) {
        this._selected.delete(value)
      } else {
        this._selected.add(value)
      }
    } else {
      // Single-select: replace
      this._selected.clear()
      this._selected.add(value)
    }

    this._updateHiddenInput()
    this._updateVisual()
  }

  // === Private ===

  _restoreFromUrl() {
    const params = new URLSearchParams(window.location.search)
    const name = this.hiddenInputTarget.name

    // Пробуем прочитать из URL
    if (name.endsWith("_in[]")) {
      const baseName = name.replace(/_in\[\]$/, "")
      const values = params.getAll(`${baseName}[in][]`)
      if (values.length > 0) {
        this._selected = new Set(values)
        this._syncHiddenInput()
        return
      }
    } else {
      const val = params.get(name)
      if (val !== null && val !== "") {
        this._selected = new Set([val])
        this._syncHiddenInput()
        return
      }
    }

    // Если нет в URL — пробуем default
    const defaultVal = this.hiddenInputTarget.dataset.defaultValue
    if (defaultVal) {
      this._selected = new Set(defaultVal.split(",").filter(v => v !== ""))
      this._syncHiddenInput()
    }
  }

  // Обновляет hidden input БЕЗ диспатча change (для восстановления из URL)
  _syncHiddenInput() {
    const value = Array.from(this._selected).join(",")
    this.hiddenInputTarget.value = value
  }

  // Обновляет hidden input И диспатчит change (для пользовательского выбора → auto-apply)
  _updateHiddenInput() {
    this._syncHiddenInput()
    this.hiddenInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  _updateVisual() {
    const buttons = this.element.querySelectorAll("button[data-value]")

    const activeClasses = this.activeClassesValue.split(" ").filter(c => c)
    const inactiveClasses = this.inactiveClassesValue.split(" ").filter(c => c)

    buttons.forEach(btn => {
      const v = btn.dataset.value

      const isActive = (v === "" && this._selected.size === 0) || this._selected.has(v)

      if (isActive) {
        btn.classList.remove(...inactiveClasses)
        btn.classList.add(...activeClasses)
      } else {
        btn.classList.remove(...activeClasses)
        btn.classList.add(...inactiveClasses)
      }
    })
  }
}
